module.exports = __webpack_public_path__ + "img/base.7618563e.webp";